import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { CmUploadFlowComponent } from './cm-upload-flow.component';
import { SharedModule } from '@app/shared/shared.module';
import { ButtonsModule } from '../buttons/buttons.module';

@NgModule({
  declarations: [CmUploadFlowComponent],
  imports: [CommonModule, TranslateModule, SharedModule, ButtonsModule],
  exports: [CmUploadFlowComponent],
})
export class CmUploadFlowModule {}
